import React from "react";
import { icons } from "../../assets/icons";

const Security = () => {
  return (
    <div className="flex justify-between flex-wrap py-2 gap-x-20">
      <div className="flex-1 py-6">
        <div className="flex flex-1 justify-between">
          <div>
            <div className="font-size-small text-[var(--blackColor)]">
              Password
            </div>
            <div className="font-size-small text-[var(--textGray3)]">
              Last changed 3 months ago
            </div>
          </div>
          <div className="flex items-center gap-x-2 ml-5 h-fit">
            <img
              src={icons.loopIcon}
              className="w-[2.4rem] h-[1.8rem]"
              alt="change password"
            />
            <div className="font-size-small text-[var(--textRed)] underline">
              Add Number
            </div>
          </div>
        </div>
        <div className="h-[1px] w-100 bg-[var(--borderGray1)] my-6" />
        <div className="mt-10">
          <div className="font-size-small">Devices Sign-in</div>
          <table className="mt-6 text-left border-separate border-spacing-[0 0.6rem]">
            <tr className="text-[1.1rem] text-[var(--textGray3)]">
              <th className="pl-5">DEVICE TYPE</th>
              <th>OPERATING SYSTEM</th>
              <th>DATE</th>
              <th>LOCATION</th>
            </tr>
            <tr className="font-size-small border-[var(--borderGray2)]">
              <td className="flex items-center gap-x-4 py-3 border-y-[1px] border-l-[1px] rounded-s-[0.6rem] pl-5 min-w-[22rem]">
                <div className="w-[5rem] flex justify-center">
                  <img
                    className="w-[4rem] h-[2.4rem]"
                    src={icons.laptopIcon}
                    alt="laptop"
                  />
                </div>
                <div>Desktop/Laptop</div>
              </td>
              <td className="py-3 min-w-[16rem] border-y-[1px]">Windows</td>
              <td className="py-3 min-w-[16rem] border-y-[1px]">29 Jul 2023</td>
              <td className="py-3 min-w-[16rem] border-y-[1px] border-r-[1px] rounded-s-[0.6rem]">
                Gurugram
              </td>
            </tr>
            <tr className="font-size-small border-[var(--borderGray2)] rounded-2">
              <td className="flex items-center gap-x-4 py-3 border-y-[1px] border-l-[1px] rounded-s-[0.6rem] pl-5 min-w-[22rem]">
                <div className="w-[5rem] flex justify-center">
                  <img
                    className="w-[4rem] h-[2.4rem]"
                    src={icons.mobileIcon}
                    alt="mobile"
                  />
                </div>
                <div>Mobile</div>
              </td>
              <td className="py-3 min-w-[16rem] border-y-[1px]">Windows</td>
              <td className="py-3 min-w-[16rem] border-y-[1px]">29 Jul 2023</td>
              <td className="py-3 min-w-[16rem] border-y-[1px] border-r-[1px] rounded-s-[0.6rem]">
                Gurugram
              </td>
            </tr>
          </table>
        </div>

        <table></table>
      </div>
      <div className="w-[30rem] bg-[var(--offWhite)] p-8 font-size-small rounded-[1rem]">
        Make sure to use accurate and up-to-date information when adding your
        email address and mobile number.
        <br />
        <br />
        If you encounter any issues during this process, contact your company’s
        IT support or relevant department for assistance.
        <br />
        <br />
        Make sure to use accurate and up-to-date information when adding your
        email address and mobile number.
        <br />
        <br />
        If you encounter any issues during this process, contact your company’s
        IT support or relevant department for assistance.
      </div>
    </div>
  );
};

export default Security;
